/**
 * A helper function to handle the response of an HTTP request.
 * @param response an http Response object
 * @returns a Promise that resolves to the JSON representation of the response
 */
export const _handleResponse = async (response: Response): Promise<any> => {
  if (!response.ok) {
    if (response.status === 400) {
      return Promise.reject(await response.json());
    }

    // Try to parse the response body for a server-provided error message
    // (e.g. 403 returns {"message": "Invalid recaptcha"})
    let errorMessage = response.statusText;
    let body: unknown;
    try {
      body = await response.json();
      if (
        body &&
        typeof body === 'object' &&
        'message' in body &&
        typeof body.message === 'string'
      ) {
        errorMessage = body.message;
      }
    } catch {
      // response body is not JSON or is empty, fall back to statusText
    }

    const error = new Error(errorMessage);
    if (body && typeof body === 'object') {
      const responseBody = body as {
        error_code?: unknown;
        data?: { error_code?: unknown };
      };
      const errorCode =
        typeof responseBody.error_code === 'string'
          ? responseBody.error_code
          : typeof responseBody.data?.error_code === 'string'
            ? responseBody.data.error_code
            : undefined;

      if (errorCode) {
        Object.assign(error, { error_code: errorCode });
      }
    }

    throw error;
  }

  return response.json();
};
